"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _Skeleton = require("@insided/destination/uikit/Skeleton");

var _classnames = _interopRequireDefault(require("classnames"));

var _formatCount = require("@insided/shared/utils/formatCount");

var Metadata = function Metadata(_ref) {
  var categoriesCount = _ref.categoriesCount,
      visibleTopicsCount = _ref.visibleTopicsCount,
      isContainer = _ref.isContainer;
  return (0, _preact.h)("ul", {
    className: (0, _classnames.default)('text--meta', 'list--dot-seperated', 'navigation-card-metadata')
  }, categoriesCount !== undefined && isContainer && (0, _preact.h)("li", {
    className: "navigation-card-category-count"
  }, (0, _formatCount.formatCount)(categoriesCount), ' ', (0, _preact.h)(_phrase.default, {
    m: "Forum",
    p: "knowledgebase.category",
    count: {
      n: categoriesCount.toString()
    }
  })), visibleTopicsCount !== undefined && (0, _preact.h)("li", {
    className: "navigation-card-topics-count"
  }, (0, _preact.h)(_phrase.default, {
    m: "Forum",
    p: "forumList.meta.counter.topic",
    count: {
      n: (0, _formatCount.formatCount)(visibleTopicsCount)
    }
  }, function (phrase) {
    return phrase || (0, _preact.h)(_Skeleton.TextSkeleton, {
      width: "5em"
    });
  })));
};

var _default = Metadata;
exports.default = _default;